import { sendDelete, sendGet, sendPost } from "./generic"

export const postApplication = (payload) => {
    return sendPost(`Applications`, payload)
}

export const postRenewalApplication = (id, payload) => {
    return sendPost(`Applications/${id}/Renew`, payload)
}

export const completeApplication = (id) => {
    return sendPost(`Applications/${id}/Complete`)
}

export const postApplicationThreadedComments = (payload) => {
    return sendPost(`Admin/ApplicationThreadedComments`, payload)
}

export const getApplicationThreadedComments = (id) => {
    return sendGet(`Applications/${id}/ThreadedComments`)
}

export const reviewThreadedComments = (payload) => {
    return sendPost(`Applications/ThreadedComments/Reviewed`, payload)
}

export const getApplication = (id) => {
    return sendGet(`Applications/${id}`)
}

export const getApplications = ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Applications/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const getApplicationsRequiringAttention = ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Applications/RequiringAttention/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const getDashboardList = ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Applications/Dashboard/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const getRenewalsAndEmailsList = ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Applications/RenewalsAndEmails/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const searchApplications = ({ searchTerm, pageIndex, numberOfRecords, orderBy, descending }) => {
    return sendGet(`Applications/${searchTerm}/${pageIndex}/${numberOfRecords}/${orderBy}/${descending}`)
}

export const reassignUser = (payload) => {
    return sendPost(`Applications/${payload.id}/Reassign/${payload.userId}`)
}

export const reassignApplicationsToUser = (payload) => {
    return sendPost(`Applications/Reassign`, payload)
}

export const getReportingList = ({ startDate, endDate }) => {
    return sendGet(`Applications/Reporting/StartDate/${startDate}/EndDate/${endDate}`)
}

export const exportReportingList = ({ startDate, endDate }) => {
    return sendGet(`Applications/Reporting/StartDate/${startDate}/EndDate/${endDate}/Export`)
}

export const postSignedApplicationFile = (id, binaryFile) => {
    return sendPost(`Applications/${id}/SignedApplicationFile`, binaryFile)
}

export const uploadSurplusLines = (id, binaryFiles) => {
    return sendPost(`Applications/${id}/SurplusLinesFile`, binaryFiles)
}

export const uploadTriaFiles = (id, binaryFiles) => {
    return sendPost(`Applications/${id}/TriaFile`, binaryFiles)
}

export const postLostRunFile = (id, binaryFile) => {
    return sendPost(`Applications/${id}/LossRunsFile`, binaryFile)
}

export const bindYourQuote = (payload) => {
    let { coverageId, coverage, bindEffectiveDate, coverageDisplayName, id } = payload
    return sendPost(`Applications/${id}/Bind`, {
        coverage,
        coverageId,
        bindEffectiveDate,
        coverageDisplayName
    })
}

export const changeApplicationStatus = ({ id, status }) => {
    return sendPost(`Applications/${id}/Status/${status}`)
}

export const downloadQuotePDF = (id) => {
    return sendGet(`Applications/${id}/QuotePdf`)
}

export const downloadFormPDF = (id) => {
    return sendGet(`Applications/${id}/FormPdf`)
}

export const renewApplication = (id) => {
    return sendPost(`Applications/${id}/Renew`)
}

export const getBindFiles = (id) => {
    return sendGet(`Applications/${id}/BindFiles`)
}
export const getSurplusAndTria = (id) => {
    return sendPost(`Applications/SurplusLinesAndTriaFiles/${id}/Download`)
}
export const downloadLossRuns = (id) => {
    return sendPost(`Applications/LossRunsFiles/${id}/Download`)
}

export const deleteLossRuns = (id) => {
    return sendDelete(`Applications/LossRunsFiles/${id}`)
}

export const downloadSurplusFiles = (id) => {
    return sendPost(`Applications/SurplusLinesFiles/${id}/Download`)
}

export const deleteSurplusFiles = (id) => {
    return sendDelete(`Applications/SurplusLinesFiles/${id}`)
}

export const downloadTriaFiles = (id) => {
    return sendPost(`Applications/TriaFiles/${id}/Download`)
}

export const deleteTriaFiles = (id) => {
    return sendDelete(`Applications/TriaFiles/${id}`)
}

export const downloadSignedApplication = (id) => {
    return sendPost(`Applications/SignedApplicationFiles/${id}/Download`)
}

export const deleteSignedApplication = (id) => {
    return sendDelete(`Applications/SignedApplicationFiles/${id}`)
}

export const getUnderwriterReferralReasonQuestionMaps = (id) => {
    return sendGet(`Admin/UnderwriterReferralReasonQuestionMaps`)
}
